<template>
  <div>
    <spinner-loader v-if="!showListView && loadingStuff" :loadingStuff="loadingStuff" />
    <app-template />

    <div class="uk-container uk-container-large">
      <ul class="tabs">
        <li class="tab-item">
          <a :class="selectedTab === 'schedule-tab' ? 'tab-link active' : 'tab-link'
            " @click="tabChange('selectedTab', 'schedule-tab')" href="javascript:;">Schedule</a>
        </li>
        <li class="tab-item" v-if="userData.userType === 'Admin' || userData.userType === 'Coach'">
          <a :class="selectedTab === 'pitch-tab' ? 'tab-link active' : 'tab-link'
            " @click="tabChange('selectedTab', 'pitch-tab')" href="javascript:;">Pitch booking</a>
        </li>
      </ul>
      <div class="view-toggle-wrapper">
        <button class="view-toggle-btn" @click="toggleListView" v-if="!isMobile">
          {{ showListView ? "Show Grid View" : "Show List View" }}
        </button>
      </div>

      <div class="tabs-wrapper">
        <div class="current-week-tab tab-content" v-if="selectedTab === 'schedule-tab'">
          <div class="lead-tabs-filters" v-if="scheduleData.length > 0">
            <div class="lead-filters">
              <div class="filter-group" v-if="userData.userType === 'Admin'">
                <label class="filter-label">Team</label>
                <b-form-select v-model="filterTeamId" :options="scheduleTeamFilterOptions"
                  class="filter-select" />
              </div>
              <div class="filter-group">
                <label class="filter-label">Event type</label>
                <b-form-select v-model="filterEventType" :options="scheduleEventTypeFilterOptions"
                  class="filter-select" />
              </div>
              <button v-if="filterTeamId || filterEventType" type="button"
                class="filter-reset"
                @click="filterTeamId = ''; filterEventType = ''">
                <i class="bi bi-x-circle" aria-hidden="true"></i> Reset
              </button>
            </div>
          </div>

          <div class="leads-count" v-if="scheduleData.length > 0">
            <span v-if="scheduleVisibleEventCount === scheduleTotalEventCountThisMonth">
              {{ scheduleTotalEventCountThisMonth }} event{{ scheduleTotalEventCountThisMonth === 1 ? '' : 's' }} in
              {{ getMonthName(minsData.month) }}
            </span>
            <span v-else>
              Showing {{ scheduleVisibleEventCount }} of {{ scheduleTotalEventCountThisMonth }} events in
              {{ getMonthName(minsData.month) }}
            </span>
          </div>

          <div v-if="
            scheduleVisibleEventCount === 0 &&
            (filterTeamId || filterEventType)
          " class="empty-state">
            <p>No events match your current filters.</p>
            <button type="button" class="filter-reset"
              @click="filterTeamId = ''; filterEventType = ''">
              <i class="bi bi-x-circle" aria-hidden="true"></i> Clear filters
            </button>
          </div>
          <div v-else-if="
            scheduleTotalEventCountThisMonth === 0 &&
            scheduleData.length > 0
          " class="empty-state">
            <p>No events scheduled for {{ getMonthName(minsData.month) }} {{ minsData.year }}.</p>
          </div>

          <div v-if="showListView" class="list-view-wrapper">
            <div class="cal-buttons-wrapper">
              <a class="cal-buttons" href="javascript:;" @click="changeMonth(-1, 'minsData')" v-b-tooltip.hover
                title="Previous month"><img src="./img/prev.svg" alt="Previous month" /></a>
              <a class="cal-buttons" href="javascript:;" @click="changeMonth(1, 'minsData')" v-b-tooltip.hover
                title="Next month"><img src="./img/next.svg" alt="Next month" /></a>
              <a class="cal-buttons" href="javascript:;" @click="scrollToToday()">Today</a>
            </div>
            <div class="date-year">
              {{ getMonthName(minsData.month) }} | {{ minsData.year }}
            </div>
            <div v-for="[date, events] in sortedFilteredEventsGroupedByDate" :key="date" class="list-date-group">
              <div class="list-date-header">{{ formatDateForHuman(date) }}</div>
              <div v-for="event in events" :key="event.id" class="list-event-item" @click="
                event.gameType !== 'Other'
                  ? openShowViewGameDetailsModal(event)
                  : null
                ">
                <div class="event-wrapper" :class="eventClass(event)">
                  <span v-if="
                    userData.userType === 'Admin' ||
                    userData.userType === 'Coach'
                  " class="event-text">{{ getTeamName(event.teamId) }}</span>
                  <span class="event-text" v-b-tooltip.hover :title="event.title">{{ event.title }}</span>
                  <span class="time-details-wrapper">
                    <span>{{ event.time }}
                      <span v-if="
                        event.gameType !== 'Training' &&
                        event.gameType !== 'Other'
                      ">({{ event.meetTime }})</span></span>
                    <span v-if="event.location" class="event-location" :title="event.location">{{ event.location
                      }}</span>
                  </span>

                  <div v-if="userData.userType === 'User'" class="player-response">
                    <img v-if="event.userImage !== ''" :src="getImgUrl(event.userImage)" alt=""
                      class="user-image-small" />
                    <TenantLogo v-else logo-class="login-logo" class="user-image-small" />

                    <span v-if="event.going == '1'" class="attendance-pill going">
                      <i class="bi bi-hand-thumbs-up" aria-hidden="true"></i> Going
                    </span>

                    <span v-if="event.notGoing == '1'" class="attendance-pill not-going">
                      <i class="bi bi-hand-thumbs-down" aria-hidden="true"></i> Not going
                    </span>

                    <span v-if="event.injured == '1'" class="attendance-pill injured">
                      <i class="bi bi-heart-pulse" aria-hidden="true"></i> Injured
                    </span>

                    <div class="response-buttons" v-if="
                      event.injured == '0' &&
                      event.going == '0' &&
                      event.notGoing == '0'
                    ">
                      <b-button v-if="
                        userData.userType !== 'Admin' &&
                        userData.userType !== 'Coach'
                      " @click="
                          gameResponce('Yes', userData.id, event);
                        $event.stopPropagation();
                        " variant="outline-success"><i class="bi bi-hand-thumbs-up"
                          aria-hidden="true"></i>Going</b-button>
                      <b-button v-if="
                        userData.userType !== 'Admin' &&
                        userData.userType !== 'Coach'
                      " @click="
                          openNoResponcsComments(event);
                        $event.stopPropagation();
                        " variant="outline-danger"><i class="bi bi-hand-thumbs-down" aria-hidden="true"></i>
                        No</b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="mins-stats-wrapper visual-split-fade">
            <div class="buttons-wrapper">
              <button @click="openAddEventModal()" v-if="
                userData.userType === 'Admin' || userData.userType === 'Coach'
              " class="green-button add-new-programme" v-b-tooltip.hover title="Add event">
                <i class="bi bi-calendar3" aria-hidden="true"></i>
              </button>
              <button @click="showAddGamesModal()" v-if="
                userData.userType === 'Admin' || userData.userType === 'Coach'
              " class="green-button add-new-programme" v-b-tooltip.hover title="Add Game / Training">
                <i class="bi bi-plus" aria-hidden="true"></i>
              </button>
              <button @click="showPrintScheduleModal()" class="green-button add-new-programme" v-b-tooltip.hover
                title="Print Schedule">
                <i class="bi bi-printer" aria-hidden="true"></i>
              </button>
            </div>
            <div class="cal-buttons-wrapper">
              <a class="cal-buttons" href="javascript:;" @click="changeMonth(-1, 'minsData')" v-b-tooltip.hover
                title="Previous month"><img src="./img/prev.svg" alt="Previous month" /></a>
              <a class="cal-buttons" href="javascript:;" @click="changeMonth(1, 'minsData')" v-b-tooltip.hover
                title="Next month"><img src="./img/next.svg" alt="Next month" /></a>
              <a class="cal-buttons" href="javascript:;" @click="scrollToToday()">Today</a>
            </div>
            <div class="date-year">
              {{ getMonthName(minsData.month) }} | {{ minsData.year }}
            </div>
            <div class="mins-stats-view">
              <div class="col-one-teams">
                <div class="body">Team</div>
                <div v-for="team in filteredClubTeams" :key="team.id" class="body">
                  <span :class="getTeamClassName(team.teamName) + '-teamName'">{{ team.teamName }}</span>
                </div>
              </div>
              <div class="events">
                <div v-for="(weekDay, dayIndex) in minsData.weekDays" :key="dayIndex" :class="[
                  'mins-stats-col-day-wrapper',
                  isToday(weekDay.date) ? 'today-column' : '',
                ]">
                  <div class="head">
                    {{ getDayFromDate(weekDay.date) }}
                  </div>
                  <div v-for="team in filteredClubTeams" :key="team.id + '-' + dayIndex" class="body">
                    <div v-for="event in getEventsForCell(team.id, weekDay.date)" :key="event.id || event.title"
                      :class="'grid-view event-wrapper ' + eventClass(event)" @click="
                        event.gameType === 'Other'
                          ? editOtherEvent(event)
                          : null
                        ">
                      <span class="event-text" v-b-tooltip.hover :title="event.title">{{ event.title }}</span>
                      <span>{{ event.time }}</span>
                      <span v-if="event.location" class="event-location" v-b-tooltip.hover :title="event.location">{{
                        event.location }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="current-week-tab tab-content" v-if="selectedTab === 'pitch-tab'">
        <PitchScheduler />
      </div>
    </div>

    <b-modal v-if="showAddEventModal" v-model="showAddEventModal" size="lg" title="Add an event"
      :hide-footer="Boolean(true)">
      <div class="event-schedual-club">
        <div class="form__item">
          <label class="form__label" for="name">Title</label>
          <input class="form__input" type="text" v-model="newEventData.title" id="name" />
        </div>

        <div class="form__item">
          <label class="form__label" for="start">Start time</label>
          <input class="form__input" type="time" v-model="newEventData.start_time" min="06:00" max="23:00" id="start" />
        </div>

        <div class="form__item">
          <label class="form__label" for="end">End time</label>
          <input class="form__input" type="time" v-model="newEventData.end_time" min="06:00" max="23:00" id="end" />
        </div>

        <div class="form__item uk-form dob">
          <label class="form__label" for="event_date">event Date</label>
          <VueDatePicker :locale="'en-GB'" v-model="newEventData.date" name="event_date" format="dd/MM/yyyy"
            id="event_date" />
        </div>

        <div class="form__item">
          <label class="form__label" for="userSelect">Select team</label>

          <div class="user-select-wrapper">
            <div v-for="team in clubTeams" :key="team.id">
              <input @change="ageGroupAddRemove($event)" type="checkbox" :id="team.id" :name="team.teamName"
                :value="team.id" :checked="team.selected" />
              <label :for="team.id">{{ team.teamName }}</label><br />
            </div>
          </div>
        </div>

        <div class="form__item recurring-event-checkBox-class">
          <div class="form-check">
            <input type="checkbox" class="form-check-input" id="recurringEvent" v-model="newEventData.recurringEvent" />
            <label class="form-check-label" for="recurringEvent">
              <span class="check-box-text">Make event recurring</span>
            </label>
          </div>
        </div>

        <button @click="saveEvent()" class="green-button add-new-programme">
          Add event
        </button>
      </div>
    </b-modal>

    <b-modal v-if="showAddEditGamesModal" v-model="showAddEditGamesModal" size="lg" title="Add new Game"
      :hide-footer="Boolean(true)">
      <form class="form" @submit.prevent="addEditProgrammeSubmit()">
        <div class="form__item" v-if="clubTeams.length > 1">
          <label class="form__label" for="userSelect">Select team </label>
          <select @change="setSelectedTeam($event)" id="userSelect">
            <option v-for="(clubTeam, index) in clubTeams" :value="clubTeam.teamName" :key="clubTeam.id + index">
              {{ clubTeam.teamName }}
            </option>
          </select>
        </div>

        <div class="form__item">
          <label class="form__label" for="selectSection">Select type of game</label>
          <b-form-select id="compressureType" text="select type" v-model="newGameData.gameType"
            @change="populateFirstTeamSelectedData($event)">
            <option v-for="(i, index) in selectTypeOfGameoptions" :key="index" :value="i.value">
              {{ i.text }}
            </option>
          </b-form-select>
        </div>
        <div class="form__item">
          <label class="form__label" for="homeTeamSection">Selected team</label>
          <span>{{ newGameData.teamName }}</span>
        </div>
        <div class="form__item" v-if="showTeamChange === true">
          <label class="form__label" for="homeTeamSection">Change team</label>

          <select @change="setSelectedTeam($event)" id="userSelect">
            <option disabled value="">Please select a team</option>
            <option v-for="(clubTeam, index) in clubTeams" :value="clubTeam.teamName" :key="clubTeam.id + index">
              {{ clubTeam.teamName }}
            </option>
          </select>
        </div>

        <div v-if="newGameData.gameType !== 'Training'" class="form__item">
          <label v-if="
            leagueTeams.length > 0 && newGameData.gameType === 'League game'
          " class="form__label" for="competitionSection">Select opposition team</label>

          <label v-else class="form__label" for="competitionSection">Add opposition team</label>

          <select v-if="
            leagueTeams.length > 0 && newGameData.gameType === 'League game'
          " @change="populateSelectedTeamVenue($event, 'newGameData')" id="competitionSection">
            <option disabled value="">Please select an opposition team</option>
            <option v-for="team in leagueTeams" v-bind:key="team.id" :value="team.id">
              {{ team.teamName }}
            </option>
          </select>
          <input v-else id="competitionSection" type="text" v-model="newGameData.opposition"
            name="competitionSection" />
        </div>
        <div class="form__item">
          <label class="form__label" for="matchDate">
            <span>{{ newGameData.gameType }}</span>
            Date</label>
          <VueDatePicker :locale="'en-GB'" wrapper-class="fullscreen-when-on-mobile" :min-date="new Date()"
            v-model="newGameData.matchDate" name="matchDate" id="matchDate" format="dd/MM/yyyy"
            :enable-time-picker="false" />
        </div>
        <div class="form__item">
          <label class="form__label" for="kickOff">
            <span v-if="newGameData.gameType === 'Training'">Start</span>
            <span v-else>Kick off</span>
            time</label>
          <input id="kickOff" type="time" min="06:00" max="23:00" v-model="newGameData.kickOffTime" name="kickOff" />
        </div>
        <div class="form__item" v-if="newGameData.gameType === 'Training'">
          <label class="form__label" for="endTime">End time</label>
          <input id="endTime" type="time" min="06:00" max="23:00" v-model="newGameData.endTime" name="endTime" />
        </div>

        <PitchSelect :pitches="pitches" @pitchChange="pitchChange" :gameData="newGameData" />

        <template v-if="togglePitchDetails === false">
          <div class="form__item">
            <label class="form__label" for="location">Location name</label>
            <input id="location" type="text" v-model="newGameData.locationName" name="location" />
          </div>
          <div class="form__item">
            <label class="form__label" for="address">Location address</label>
            <input id="address" type="text" v-model="newGameData.address" name="address" />
          </div>
          <div class="form__item">
            <label class="form__label" for="postCode">Location postCode</label>
            <input id="postCode" type="text" v-model="newGameData.postCode" name="postCode" />
          </div>
          <div class="form__item">
            <label class="form__label" for="selectpitchType">Select Pitch type</label>
            <select v-model="newGameData.pitchType" id="selectpitchType">
              <option disabled value="">Please select a pitch type</option>
              <option value="4G">4G</option>
              <option value="3G">3G</option>
              <option value="Grass">Grass</option>
              <option value="Other">Other</option>
            </select>
          </div>
        </template>

        <template v-else>
          <div class="form__item">
            <label class="form__label" for="location">Location name</label>
            <input id="location" type="text" v-model="newGameData.locationName" name="location" disabled="true" />
          </div>
          <div class="form__item">
            <label class="form__label" for="address">Location address</label>
            <input id="address" type="text" v-model="newGameData.address" name="address" disabled="true" />
          </div>
          <div class="form__item">
            <label class="form__label" for="postCode">Location postCode</label>
            <input id="postCode" type="text" v-model="newGameData.postCode" name="postCode" disabled="true" />
          </div>
          <div class="form__item">
            <label class="form__label" for="selectpitchType">Select Pitch type</label>
            <input id="selectpitchType" type="text" v-model="newGameData.pitchType" name="selectpitchType"
              disabled="true" />
          </div>
        </template>

        <div class="form__item" v-if="newGameData.gameType !== 'Training'">
          <label class="form__label" for="stripType">Strip type</label>
          <input id="stripType" type="text" v-model="newGameData.stripType" name="stripType" />
        </div>
        <div class="form__item" v-if="newGameData.gameType !== 'Training'">
          <label class="form__label" for="meetTime">Meet time</label>
          <input id="meetTime" type="time" min="06:00" max="23:00" v-model="newGameData.meetTime" name="meetTime" />
        </div>

        <div v-if="newGameData.gameType !== 'Training'" class="form__item">
          <label class="form__label" for="notes">Home game</label>
          <b-form-checkbox id="home-game-event-checkBox" v-model="newGameData.home_team"
            name="home-game-event-checkBox">
          </b-form-checkbox>
        </div>
        <div class="form__item">
          <label class="form__label" for="notes">Notes</label>
          <textarea id="notes" type="text" v-model="newGameData.notes" name="notes"></textarea>
        </div>

        <div v-if="newGameData.gameType === 'Training'" class="form__item recurring-event-checkBox-class">
          <b-form-checkbox id="recurring-event-checkBox" v-model="recurringEvent" name="recurring-event-checkBox"
            @change="toggleRecurringEvent()">
            <span class="check-box-text">Make event recurring</span>
          </b-form-checkbox>
        </div>

        <div class="form__item" v-if="recurringEvent === true">
          <label class="form__label" for="recurringEventSelect">Select recurring type</label>
          <select v-model="newGameData.recurringEventType" id="recurringEventSelect">
            <option disabled value="">
              Please select a recurring event type
            </option>
            <option value="7">Weekly</option>
            <option value="14">By weekly</option>
          </select>
        </div>

        <div class="form__item">
          <button type="submit" class="green-button">Add game</button>
        </div>
      </form>
    </b-modal>

    <b-modal v-if="showPrintScheduleModalVisible" v-model="showPrintScheduleModalVisible" modal-class="modal-fullscreen"
      size="xl" title="Print Schedule" :hide-footer="Boolean(true)">
      <div class="search-filter">
        <div class="form__item">
          <b-button @click="produceTheAcademySchedulePDF()" class="edit-pitch-button" v-b-tooltip.hover
            title="Produce The Academy Schedule PDF" variant="outline-warning">
            Print Schedule
          </b-button>
        </div>

        <div class="player-report-content">
          <iframe id="theAcademySchedulePdf_preview" src="" />
        </div>
      </div>
    </b-modal>

    <b-modal v-if="showEditOtherEventModal" v-model="showEditOtherEventModal" size="lg" title="Edit an event"
      :hide-footer="Boolean(true)">
      <div class="event-schedual-club">
        <div class="form__item">
          <label class="form__label" for="name">Title</label>
          <input class="form__input" type="text" v-model="editOtherEventData.title" id="name" />
        </div>

        <div class="form__item">
          <label class="form__label" for="start">Start time</label>
          <input class="form__input" type="time" v-model="editOtherEventData.time" min="06:00" max="23:00" id="start" />
        </div>

        <div class="form__item">
          <label class="form__label" for="end">End time</label>
          <input class="form__input" type="time" v-model="editOtherEventData.endTime" min="06:00" max="23:00"
            id="end" />
        </div>

        <div class="form__item uk-form dob">
          <label class="form__label" for="event_date">event Date</label>
          <VueDatePicker :locale="'en-GB'" v-model="editOtherEventData.date" format="dd/MM/yyyy" name="event_date"
            id="event_date" />
        </div>

        <div class="buttons-wrapper">
          <button @click="editOtherEventCall()" class="green-button">
            edit event
          </button>

          <b-button @click="confirmDeleteOtherEvent()" variant="outline-danger" v-b-tooltip.hover title="Delete"><i
              class="bi bi-trash" aria-hidden="true"></i></b-button>
        </div>
      </div>
    </b-modal>

    <b-modal v-if="showViewGameDetails" v-model="showViewGameDetails" size="xl" :hide-footer="true"
      @close="showViewGameDetails = false">
      <h2 class="small-title">
        {{ selectedGame.gameType }}
        <span v-if="selectedGame.gameType !== 'Training'">V {{ selectedGame.opposition }}</span>
        <span v-if="selectedGame.gameType === 'Training'" class="small-text">{{
          setPitchZoneText(selectedGame)
          }}</span>
      </h2>
      <div class="match-details">
        <div class="details">
          <i v-if="selectedGame.gameType !== 'Training'" class="bi bi-calendar2-day" aria-hidden="true"></i>
          <i v-if="selectedGame.gameType === 'Training'" class="bi bi-alarm" aria-hidden="true"></i>

          <div class="date-times-wrapper">
            <span class="match-date header-text-bold">{{
              getDayAndDate(selectedGame.matchDate)
              }}</span>
            <div class="times-wrapper">
              <span v-if="selectedGame.gameType !== 'Training'"> at </span>
              <span>{{
                formatISOStringDateAndTime(selectedGame.kickOffTime)
                }}</span>
              <span v-if="selectedGame.gameType === 'Training'">- {{ formatISOStringDateAndTime(selectedGame.endTime)
                }}</span>
            </div>
          </div>
        </div>

        <div class="details" v-if="selectedGame.gameType !== 'Training'">
          <i class="bi bi-alarm" aria-hidden="true"></i>
          <div class="date-times-wrapper">
            <span>Report for:
              {{ formatISOStringDateAndTime(selectedGame.meetTime) }}</span>
          </div>
        </div>

        <div class="details">
          <i class="bi bi-pin-map" aria-hidden="true"></i>
          <div class="date-times-wrapper">
            <span class="venue-text header-text-bold">{{ selectedGame.locationName }}
              {{ selectedGame.pitchType }}</span>
            <div class="times-wrapper">
              <span>{{ selectedGame.address }} {{ selectedGame.postCode }}</span>
              <a class="map-link" v-if="selectedGame.postCode !== ''"
                :href="`https://maps.google.fr/maps?q=${selectedGame.postCode}`" target="_blank">
                <div class="map-icon-text">
                  <iframe width="100%" height="200px" frameborder="0" style="border: 0" :src="googleMapsEmbedUrl"
                    allowfullscreen>
                  </iframe>
                </div>
              </a>
            </div>
          </div>
        </div>

        <div class="details" v-if="selectedGame.gameType !== 'Training'">
          <i class="bi bi-person" aria-hidden="true"></i>
          <div class="date-times-wrapper">
            <span>Strip: {{ selectedGame.stripType }}</span>
          </div>
        </div>

        <p v-if="selectedGame.notes != ''">
          <i class="bi bi-chat-right-text" aria-hidden="true"></i>
          {{ selectedGame.notes }}
        </p>
      </div>

      <div v-if="checkUserIsAttendingGame() === false" class="player-game-responce">
        <b-button v-if="userData.userType !== 'Admin' && userData.userType !== 'Coach'" @click="gameResponce('Yes')"
          variant="outline-success"><i class="bi bi-hand-thumbs-up" aria-hidden="true"></i> Yes
          going</b-button>
        <b-button v-if="userData.userType !== 'Admin' && userData.userType !== 'Coach'" @click="gameResponce('No')"
          variant="outline-danger"><i class="bi bi-hand-thumbs-down" aria-hidden="true"></i> No can't
          make it</b-button>
      </div>
      <div v-else class="player-game-responce">
        <b-button disabled variant="success"><i class="bi bi-hand-thumbs-up" aria-hidden="true"></i>
          Attending</b-button>
        <b-button v-if="userData.userType !== 'Admin' && userData.userType !== 'Coach'" @click="gameResponce('No')"
          variant="outline-danger"><i class="bi bi-hand-thumbs-down" aria-hidden="true"></i> No can't
          make it</b-button>
        <p class="attending-game">
          <i class="bi bi-hand-thumbs-up" aria-hidden="true"></i> You are
          currently attending this
          <span v-if="selectedGame.gameType === 'Training'">Session</span>
          <span v-else>Game</span>
        </p>
      </div>

      <div class="player-game-numbers">
        <ul class="tabs">
          <li class="tab-item">
            <a :class="playerAvailabilityTab === 'going-tab'
                ? 'tab-link active'
                : 'tab-link'
              " @click="tabChange('playerAvailabilityTab', 'going-tab')" href="javascript:;">Going</a>
          </li>
          <li class="tab-item">
            <a :class="playerAvailabilityTab === 'not-going-tab'
                ? 'tab-link active'
                : 'tab-link'
              " @click="tabChange('playerAvailabilityTab', 'not-going-tab')" href="javascript:;">Not Going</a>
          </li>
          <li class="tab-item">
            <a :class="playerAvailabilityTab === 'no-response-tab'
                ? 'tab-link active'
                : 'tab-link'
              " @click="tabChange('playerAvailabilityTab', 'no-response-tab')" href="javascript:;">No Response</a>
          </li>

          <li class="tab-item">
            <a :class="playerAvailabilityTab === 'injured-tab'
                ? 'tab-link active'
                : 'tab-link'
              " @click="tabChange('playerAvailabilityTab', 'injured-tab')" href="javascript:;">Injured</a>
          </li>
        </ul>

        <div class="tabs-wrapper">
          <div class="tab-content" v-if="playerAvailabilityTab === 'going-tab'">
            <ul class="going-list player-list">
              <li v-for="(attendee, index) in selectedGameAttendees" :key="index">
                <div v-if="attendee.going == '1'">
                  <img v-if="
                    attendee.userImage !== null &&
                    attendee.userImage !== '' &&
                    attendee.userImage !== undefined
                  " :src="getImgUrl(attendee.userImage)" alt="" class="user-image-small" />
                  <TenantLogo v-else logo-class="login-logo" class="user-image-small" />
                </div>

                <p v-if="attendee.going == '1'">
                  {{ attendee.name }}
                  <span class="going"><i class="bi bi-hand-thumbs-up" aria-hidden="true"></i></span>

                  <span v-if="
                    userData.userType === 'Admin' ||
                    userData.userType === 'Coach'
                  ">
                    <b-form-select v-model="gameResponceValueChange" @change="gameResponceChange(attendee.user_id)"
                      class="mb-3">
                      <b-form-select-option :value="null">Change player response</b-form-select-option>
                      <b-form-select-option value="No">Not Going</b-form-select-option>
                      <b-form-select-option value="Injured">Injured</b-form-select-option>
                    </b-form-select>
                  </span>
                </p>
              </li>
            </ul>
          </div>
          <div class="tab-content" v-if="playerAvailabilityTab === 'not-going-tab'">
            <ul class="not-going-list player-list">
              <li v-for="(attendee, index) in selectedGameAttendees" :key="index">
                <div v-if="attendee.notGoing == '1'">
                  <img v-if="
                    attendee.userImage !== null &&
                    attendee.userImage !== '' &&
                    attendee.userImage !== undefined
                  " :src="getImgUrl(attendee.userImage)" alt="" class="user-image-small" />
                  <TenantLogo v-else logo-class="login-logo" class="user-image-small" />
                </div>

                <p v-if="attendee.notGoing == '1'">
                  {{ attendee.name }}
                  <span class="not-going"><i class="bi bi-hand-thumbs-down" aria-hidden="true"></i></span>

                  <span v-if="
                    userData.userType === 'Admin' ||
                    userData.userType === 'Coach'
                  ">
                    <b-form-select v-model="gameResponceValueChange" @change="gameResponceChange(attendee.user_id)"
                      class="mb-3">
                      <b-form-select-option :value="null">Change player response</b-form-select-option>
                      <b-form-select-option value="Yes">Going</b-form-select-option>
                    </b-form-select>

                    <span class="player-comment" v-if="attendee.comments !== null">{{ attendee.comments }}</span>
                  </span>
                </p>
              </li>
            </ul>
          </div>

          <div class="tab-content" v-if="playerAvailabilityTab === 'no-response-tab'">
            <ul class="no-response-list player-list">
              <li v-for="(attendee, index) in noResponsePlayersList" :key="index">
                <img v-if="
                  attendee.userImage !== null &&
                  attendee.userImage !== '' &&
                  attendee.userImage !== undefined
                " :src="getImgUrl(attendee.userImage)" alt="" class="user-image-small" />
                <TenantLogo v-else logo-class="login-logo" class="user-image-small" />
                <p>
                  {{ attendee.name }}
                  <span v-if="
                    userData.userType === 'Admin' ||
                    userData.userType === 'Coach'
                  ">
                    <b-form-select v-model="gameResponceValueChange" @change="gameResponceChange(attendee.id)"
                      class="mb-3">
                      <b-form-select-option :value="null">Change player response</b-form-select-option>
                      <b-form-select-option value="No">Not Going</b-form-select-option>
                      <b-form-select-option value="Yes">Going</b-form-select-option>
                      <b-form-select-option value="Injured">Injured</b-form-select-option>
                    </b-form-select>
                  </span>
                </p>
              </li>
            </ul>
          </div>

          <div class="tab-content" v-if="playerAvailabilityTab === 'injured-tab'">
            <ul class="injured-list player-list">
              <li v-for="(attendee, index) in selectedGameAttendees" :key="index">
                <div v-if="attendee.injured == '1'">
                  <img v-if="
                    attendee.userImage !== null &&
                    attendee.userImage !== '' &&
                    attendee.userImage !== undefined
                  " :src="getImgUrl(attendee.userImage)" alt="" class="user-image-small" />
                  <TenantLogo v-else logo-class="login-logo" class="user-image-small" />
                </div>

                <p v-if="attendee.injured == '1'">
                  {{ attendee.name }}
                  <span class="not-going"><i class="bi bi-exclamation-circle" aria-hidden="true"></i></span>

                  <span v-if="
                    userData.userType === 'Admin' ||
                    userData.userType === 'Coach'
                  ">
                    <b-form-select v-model="gameResponceValueChange" @change="gameResponceChange(attendee.user_id)"
                      class="mb-3">
                      <b-form-select-option :value="null">Change player response</b-form-select-option>
                      <b-form-select-option value="Yes">Going</b-form-select-option>
                      <b-form-select-option value="No">Not Going</b-form-select-option>
                    </b-form-select>
                  </span>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal v-if="noResponseComments" v-model="noResponseComments" size="sm" title="Reason for not going"
      :hide-footer="Boolean(true)">
      <div class="form__item automatic-comments">
        <ul>
          <li @click="autoComment('Sick')">
            <img src="./img/sick.svg" /> Sick
          </li>
          <li @click="autoComment('Injured')">
            <img src="./img/injury.svg" /> Injured
          </li>
          <li @click="autoComment('Holiday')">
            <img src="./img/sunny.svg" /> Holiday
          </li>
          <li @click="autoComment('No comment')">
            <img src="./img/other.svg" /> Other
          </li>
        </ul>

        <label class="form__label" for="noResponseComment">Custom Comment</label>
        <textarea class="form__input" id="noResponseComment" v-model="noResponseEventData.comments"></textarea>

        <b-button size="lg" variant="outline-warning" @click="gameResponce('No', userData.id, noResponseEventData)">
          Save
        </b-button>
      </div>
    </b-modal>

    <img alt="" class="visually-hidden" id="png-logo" />
  </div>
</template>
<script>
import SpinnerLoader from "../../components/LoadingSpinning";
import AppTemplate from "../layouts/App";
import { CHECK_PROFILE_HAS_DATA } from "@/store/actions/user.js";
import { mapGetters } from "vuex";
import PitchScheduler from "../../components/PitchScheduler";
import { Teams } from "@/services/teams-service.js";
import { Users } from "@/services/user-service.js";
import { Games } from "@/services/games-service.js";
import { Chat } from "@/services/ChatService.js";
import { Pitches } from "@/services/coaches-pitches.js";
import { PlayerInjury } from "@/services/player-Injury-service.js";
import dayjs from "dayjs";
import moment from "moment";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import extendSeasonEndDateToFullYearMixin from "@/mixin/extendSeasonEndDateToFullYear.js";
import PitchSelect from "../../components/PitchSelect";
import JsPDF from "jspdf";
import { getTenantName } from "@/config/tenant.js";
import { getTenantId } from "@/config/tenant.js";
import setPitchZoneTextMixin from "@/mixin/pitchZoneText.js";
import TenantLogo from "@/components/TenantLogo/index.vue";

export default {
  name: "Booking",
  mixins: [extendSeasonEndDateToFullYearMixin, setPitchZoneTextMixin],
  data() {
    return {
      loadingStuff: false,
      selectedTab: "schedule-tab",
      showListView: false,
      isMobile: false,
      // Schedule filter row
      filterTeamId: "",
      filterEventType: "",
      teamGamesDataUnfilterded: [],
      selectedGameAttendees: [],
      noResponsePlayersList: [],
      noResponseEventData: {},
      allPlayerInATeamInjuryReports: [],
      teamsAttendedGamesAndTrainingData: [],
      playerAvailabilityTab: "going-tab",
      showViewGameDetails: false,
      noResponseComments: false,
      minsData: {
        year: new Date().getFullYear(),
        month: new Date().getMonth(),
        weekDays: [],
      },
      selectedGame: {},
      currentTeam: [],
      clubTeams: [],
      scheduleData: [],
      allTeamDataBeforFilterApplied: [],
      showAddEventModal: false,
      showAddEditGamesModal: false,
      showPrintScheduleModalVisible: false,
      showEditOtherEventModal: false,
      gameResponceValueChange: null,
      selectedPlayerAttendanceData: {},
      // Add other required properties here as needed
      // ...existing code...
      scheduleStartDate: localStorage.getItem("selectedSeasonYear")
        ? localStorage.getItem("currentPlayingseasonStartDate")
        : moment().subtract(1, "months").format("YYYY-MM-DD"),
      scheduleEndDate: localStorage.getItem("selectedSeasonYear")
        ? localStorage.getItem("currentPlayingseasonEndDate")
        : moment().add(2, "months").format("YYYY-MM-DD"),
      userData: {},
      recurringEvent: false,
      showTeamChange: false,
      leagueTeams: [],
      editOtherEventData: {},
      listOfSelectedYear: [],
      hasInitiallyScrolled: false,
      pitches: [],
      selectedTeam: {},
      printScheduleData: {},
      selectTypeOfGameoptions: [
        { value: "Training", text: "Training" },
        { value: "League game", text: "League game" },
        { value: "Friendly", text: "Friendly" },
        { value: "Cup game", text: "Cup game" },
        { value: "Other", text: "Other" },
      ],
      newEventData: {
        title: "",
        start_time: "",
        end_time: "",
        date: "",
        recurringEvent: false,
        teamId: "",
        teamName: "",
        opposition: "",
        matchDate: "",
        kickOffTime: "",
        endTime: "",
        locationName: "",
        address: "",
        postCode: "",
        pitchType: "",
        stripType: "",
        meetTime: "",
        notes: "",
        home_team: false,
        recurringEventType: null,
        pitch_id: "",
        pitch_zone: null,
        togglePitchDetails: false,
      },
    };
  },
  computed: {
    ...mapGetters(["getProfile"]),
    googleMapsEmbedUrl() {
      try {
        if (!this.selectedGame) {
          return "";
        }
        // Build the query string from locationName, address, and postCode
        const location = [
          this.selectedGame.locationName,
          this.selectedGame.address,
          this.selectedGame.postCode,
        ]
          .filter(Boolean)
          .join(", ");
        const encodedLocation = encodeURIComponent(location);
        // Read from build-time env so the key isn't shipped in source control.
        // Set VUE_APP_GOOGLE_MAPS_API_KEY in .env.local. The previous hardcoded
        // key MUST be rotated in the Google Cloud Console — it was checked in.
        const apiKey = process.env.VUE_APP_GOOGLE_MAPS_API_KEY || "";
        if (!apiKey) {
          console.warn(
            "VUE_APP_GOOGLE_MAPS_API_KEY is not set; map embed will not load.",
          );
          return "";
        }
        return `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${encodedLocation}&maptype=roadmap`;
      } catch (error) {
        console.error("Error in googleMapsEmbedUrl:", error);
        return "";
      }
    },
    eventsGroupedByDate() {
      try {
        // Group scheduleData by normalized date (YYYY-MM-DD)
        const grouped = {};
        (this.scheduleData || []).forEach(function (event) {
          if (event && event.date) {
            const date = moment(event.date).format("YYYY-MM-DD");
            if (!grouped[date]) grouped[date] = [];
            grouped[date].push(event);
          }
        });
        return grouped;
      } catch (error) {
        console.error("Error in eventsGroupedByDate:", error);
        return {};
      }
    },
    filteredEventsGroupedByDate() {
      try {
        // Only show events for minsData.year and minsData.month, plus apply
        // the schedule's Team and Event-type filters when set.
        const grouped = {};
        if (!this.minsData || !this.scheduleData) {
          return grouped;
        }

        const teamFilter = this.filterTeamId
          ? Number(this.filterTeamId)
          : null;
        const typeFilter = this.filterEventType || null;

        (this.scheduleData || []).forEach(function (event) {
          if (event && event.date) {
            const eventDate = moment(event.date);
            if (
              eventDate.year() === Number(this.minsData.year) &&
              eventDate.month() === Number(this.minsData.month)
            ) {
              if (teamFilter && Number(event.teamId) !== teamFilter) return;
              if (typeFilter && event.gameType !== typeFilter) return;

              const date = eventDate.format("YYYY-MM-DD");
              if (!grouped[date]) grouped[date] = [];
              grouped[date].push(event);
            }
          }
        }, this);
        return grouped;
      } catch (error) {
        console.error("Error in filteredEventsGroupedByDate:", error);
        return {};
      }
    },

    // The grid view iterates teams as rows; honour the Team filter here so
    // selecting a single team collapses the grid to just that row.
    filteredClubTeams() {
      if (!this.filterTeamId) return this.clubTeams || [];
      const target = Number(this.filterTeamId);
      return (this.clubTeams || []).filter(
        (t) => Number(t.id) === target || Number(t.teamId) === target,
      );
    },

    scheduleTeamFilterOptions() {
      const teams = (this.clubTeams || [])
        .map((t) => ({
          value: String(t.id ?? t.teamId ?? ""),
          text: t.teamName,
        }))
        .filter((o) => o.value !== "");
      return [{ value: "", text: "All teams" }, ...teams];
    },

    scheduleEventTypeFilterOptions() {
      return [
        { value: "", text: "All event types" },
        { value: "League game", text: "League game" },
        { value: "Friendly", text: "Friendly" },
        { value: "Cup game", text: "Cup game" },
        { value: "Training", text: "Training" },
        { value: "Other", text: "Other" },
      ];
    },

    scheduleVisibleEventCount() {
      try {
        return Object.values(this.filteredEventsGroupedByDate || {}).reduce(
          (sum, arr) => sum + (arr ? arr.length : 0),
          0,
        );
      } catch (e) {
        return 0;
      }
    },

    scheduleTotalEventCountThisMonth() {
      try {
        if (!this.minsData || !this.scheduleData) return 0;
        return (this.scheduleData || []).reduce((count, event) => {
          if (!event || !event.date) return count;
          const eventDate = moment(event.date);
          if (
            eventDate.year() === Number(this.minsData.year) &&
            eventDate.month() === Number(this.minsData.month)
          ) {
            return count + 1;
          }
          return count;
        }, 0);
      } catch (e) {
        return 0;
      }
    },
    sortedFilteredEventsGroupedByDate() {
      try {
        const grouped = this.filteredEventsGroupedByDate || {};
        const today = moment().format("YYYY-MM-DD");
        const dates = Object.keys(grouped).sort(
          (a, b) => moment(a).valueOf() - moment(b).valueOf(),
        );

        // Split dates into today, future dates (after today), and past dates (before today)
        const todayEvents = dates.filter((date) => date === today);
        const futureDates = dates.filter((date) => moment(date).isAfter(today));
        const pastDates = dates.filter((date) => moment(date).isBefore(today));

        // Order: Today first, then future dates chronologically, then past dates chronologically
        const orderedDates = [...todayEvents, ...futureDates, ...pastDates];

        return orderedDates.map((date) => [date, grouped[date]]);
      } catch (error) {
        console.error("Error in sortedFilteredEventsGroupedByDate:", error);
        return [];
      }
    },
  },
  mounted() {
    // Detect mobile screen and set view automatically
    this.isMobile = window.innerWidth <= 768;
    if (this.isMobile) {
      this.showListView = true;
    } else {
      this.showListView = false; // Ensure grid view is shown on desktop
    }
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  components: {
    AppTemplate,
    SpinnerLoader,
    PitchScheduler,
    VueDatePicker,
    PitchSelect,
    TenantLogo,
  },
  async created() {
    this.minsData.weekDays = this.populateMinsCal(
      Number(dayjs().format("YYYY")),
      Number(dayjs().month()),
      "minsData",
    );
    const response = await this.$store.dispatch(CHECK_PROFILE_HAS_DATA);

    if (response === true) {
      this.setUser();
      this.getAllGamesEventsByClubId();
    } else {
      const clientId = JSON.parse(
        localStorage.getItem("the_w_selectedClientId"),
      );
      this.getUserById(clientId);
    }

    // Auto-scroll to current day on initial load
    this.$nextTick(() => {
      if (!this.hasInitiallyScrolled) {
        this.scrollToToday();
        this.hasInitiallyScrolled = true;
      }
    });
    let mainLogoSRC = document.getElementById("main-logo").src;
    this.base64SvgToBase64Png(mainLogoSRC, 200).then((pngSrc) => {
      document.getElementById("png-logo").src = pngSrc;
    });
  },
  methods: {
    gameResponceChange(userId) {
      this.gameResponce(this.gameResponceValueChange, userId);
    },
    autoComment(comment) {
      this.noResponseEventData.comments = comment;
      this.gameResponce("No", this.userData.id, this.noResponseEventData);
      this.noResponseComments = false;
    },
    openNoResponcsComments(event) {
      this.noResponseEventData = event;
      this.noResponseComments = true;
    },
    getImgUrl(pic) {
      return pic !== undefined && pic !== "" ? `/images/${pic}` : "";
    },
    setResponce(responceType) {
      if (responceType === "Yes") {
        this.selectedGame.going = 1;
        this.selectedGame.notGoing = 0;
        this.selectedGame.noResponse = 0;
        this.selectedGame.injured = 0;
      }
      if (responceType === "No") {
        this.selectedGame.notGoing = 1;
        this.selectedGame.going = 0;
        this.selectedGame.noResponse = 0;
        this.selectedGame.injured = 0;
      }

      if (responceType === "Injured") {
        this.selectedGame.injured = 1;
        this.selectedGame.going = 0;
        this.selectedGame.notGoing = 0;
        this.selectedGame.noResponse = 0;
      }
    },
    async gameResponce(responceType, userId, game) {
      this.noResponseComments = false;
      try {
        if (game !== undefined) {
          this.selectedGame = game;
        }

        this.setResponce(responceType);
        let selectedUserId = userId || this.userData.id;
        let teamAgeGroup = "";

        if (this.clubTeams && Array.isArray(this.clubTeams)) {
          this.clubTeams.map((team) => {
            if (team.id === Number(this.selectedGame.teamId)) {
              teamAgeGroup = team.age_group;
            }
          });
        }

        const userData = {
          gameId: this.selectedGame.id,
          userId: selectedUserId,
          kickOffTime: this.selectedGame.kickOffTime,
          going: this.selectedGame.going,
          noResponse: this.selectedGame.noResponse,
          injured: this.selectedGame.injured,
          notGoing: this.selectedGame.notGoing,
          teamId: this.selectedGame.teamId,
          gameType: this.selectedGame.gameType,
          age_group: teamAgeGroup || "",
          comments:
            this.noResponseEventData.comments !== undefined
              ? this.noResponseEventData.comments
              : null,
          action: "setUserGameResponse",
        };

        const responce = await Games.find(userData).catch((error) => {
          console.log(error);
        });

        if (responce.status === 200) {
          this.showViewGameDetails = false;
          this.getAllAttendeesForAGame();
          this.getAllGamesAttendeesByTeamId(
            this.selectedTeam.season_start_date,
            this.selectedTeam.season_end_date,
          );
          this.gameResponceValueChange = "";
          this.noResponseEventData = {};

          this.$toast.info("Game response updated successfully.", {
            title: "Saved",
            toaster: "b-toaster-top-right",
            solid: true,
            appendToast: true,
            variant: "success",
          });
        }
      } catch (error) {
        console.error("Error in gameResponce:", error);
      }
    },
    checkUserIsAttendingGame() {
      let responce = false;
      if (this.selectedGameAttendees.length > 0) {
        this.selectedGameAttendees.filter((game) => {
          if (String(game.user_id) === String(this.userData.id)) {
            responce = game.going == 1 ? true : false;
          }
        });
      }

      return responce;
    },
    addInjuryToPlayer() {
      this.currentTeam = this.currentTeam.map((player) => {
        const hasInjury = this.allPlayerInATeamInjuryReports.some(
          (injury) =>
            player.id == injury.player_id &&
            injury.injury_status !== "Fully recoverd",
        );
        player.injury = hasInjury;
        return player;
      });
    },
    async getAllPlayerInClubInjuryReports() {
      const userData = {
        clubId: this.selectedTeam.clubId,
        season_start_date: localStorage.getItem("selectedSeasonYear")
          ? localStorage.getItem("currentPlayingseasonStartDate")
          : this.selectedTeam.season_start_date,
        season_end_date: localStorage.getItem("selectedSeasonYear")
          ? localStorage.getItem("currentPlayingseasonEndDate")
          : this.selectedTeam.season_end_date,
        action: "getAllPlayerInClubInjuryReports",
      };

      const responce = await PlayerInjury.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.allPlayerInATeamInjuryReports = responce.data;
        this.addInjuryToPlayer();
      }
    },
    async getUserByTeamId() {
      this.currentTeam = [];
      const userData = {
        teamId: this.selectedGame.teamId,
        action: "getUserByTeamId",
      };
      const responce = await Users.find(userData).catch((error) => {
        console.log(error);
      });
      if (responce.data.length > 0) {
        this.currentTeam = responce.data;
        this.getAllPlayerInClubInjuryReports();
        this.getAllGamesAttendeesByTeamId(
          this.selectedTeam.season_start_date,
          this.selectedTeam.season_end_date,
        );
        this.listOfSelectedplayerIds = this.currentTeam.map(
          (player) => player.id,
        );
      }
    },
    async getAllGamesAttendeesByTeamId(startDate, endDate) {
      if (startDate === "object") {
        const startDate = this.formatMatchDate(startDate);
        const endDate = this.formatMatchDate(endDate);
      }
      const userData = {
        teamId: this.selectedTeam.id,
        season_start_date: startDate,
        season_end_date: endDate,
        action: "getAllGamesAttendeesByTeamId",
      };
      const responce = await Games.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.teamsAttendedGamesAndTrainingData = responce.data;
        this.populatePlayerAttendanceData();
      }
    },
    populatePlayerAttendanceData() {
      if (
        !this.teamsAttendedGamesAndTrainingData ||
        !Array.isArray(this.teamsAttendedGamesAndTrainingData)
      ) {
        console.warn(
          "teamsAttendedGamesAndTrainingData is not an array:",
          this.teamsAttendedGamesAndTrainingData,
        );
        // Initialize as empty array if not already an array
        this.teamsAttendedGamesAndTrainingData = [];
        return;
      }

      this.teamsAttendedGamesAndTrainingData.forEach((game) => {
        const player = this.currentTeam.find(
          (player) => player.id === game.user_id,
        );

        if (player) {
          if (game.gameType === "League game" && game.going === 1) {
            player.gameAttendance += 1;
          }

          if (game.gameType === "Training" && game.going === 1) {
            player.trainingAttendance += 1;
          }

          if (game.gameType === "Cup game" && game.going === 1) {
            player.cupGameAttendance += 1;
          }
        }
      });
    },
    noResponsePlayers() {
      if (this.selectedGameAttendees.length == 0) {
        this.noResponsePlayersList = this.currentTeam;
      } else {
        this.noResponsePlayersList = this.currentTeam.filter((player) => {
          return !this.selectedGameAttendees.some(function (attendee) {
            return player.id == attendee.user_id;
          });
        });
      }
    },
    async getAllAttendeesForAGame() {
      const userData = {
        userId: this.userData.id,
        kickOffTime: this.selectedGame.kickOffTime,
        teamId: this.selectedGame.teamId,
        action: "getAllAttendeesForAGame",
      };
      const responce = await Games.find(userData).catch((error) => {
        console.log(error);
      });
      this.selectedGameAttendees = (responce && responce.data) || [];
      this.noResponsePlayers();
    },
    async openShowViewGameDetailsModal(event) {
      this.selectedGame = event;
      await this.getUserByTeamId();
      await this.getAllAttendeesForAGame();
      this.showViewGameDetails = true;
    },
    getTeamName(teamId) {
      try {
        if (!teamId || !this.clubTeams || !Array.isArray(this.clubTeams)) {
          return "Unknown";
        }
        // Backend-loaded team rows only have `id`; the manually-pushed extras
        // ("DFC Performance School", "GK") set both `id` and `teamId`. Match
        // either so events from any source resolve to a name.
        const target = Number(teamId);
        const team = this.clubTeams.find(
          (t) => Number(t.id) === target || Number(t.teamId) === target,
        );
        return team ? team.teamName : "Unknown";
      } catch (error) {
        console.error("Error in getTeamName:", error);
        return "Unknown";
      }
    },
    toggleListView() {
      this.showListView = !this.showListView;
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
      if (this.isMobile) {
        this.showListView = true;
      }
    },
    eventClass(event) {
      if (event.gameType === "Training") return "training-style";
      if (event.gameType && event.gameType.includes("League"))
        return "league-style";
      if (
        event.gameType &&
        (event.gameType.includes("Friendlies") ||
          event.gameType.includes("Friendly"))
      )
        return "league-style";
      if (
        event.gameType &&
        event.gameType.includes("Cup") &&
        !event.gameType.includes("League")
      )
        return "cup-style";
      return "";
    },
    getTeamClassName(teamName) {
      return teamName
        .toString()
        .trim()
        .replace(/\s+/g, "-") // Replace spaces with dashes
        .replace(/[^a-zA-Z0-9-]/g, "") // Remove special characters
        .toLowerCase();
    },
    getEventsForCell(teamId, date) {
      const formattedDate = this.formatDateForDB(date);
      const typeFilter = this.filterEventType || null;
      return this.scheduleData.filter(
        (game) =>
          String(game.teamId) === String(teamId) &&
          this.formatDateForDB(game.date) === formattedDate &&
          (!typeFilter || game.gameType === typeFilter),
      );
    },
    isToday(date) {
      const today = dayjs().format("YYYY-MM-DD");
      return dayjs(date).format("YYYY-MM-DD") === today;
    },
    scrollToToday() {
      // Cancel any pending scroll-animation timeouts so rapid month nav
      // doesn't race-scroll an out-of-date column into view.
      if (this._scrollToTodayTimeouts) {
        this._scrollToTodayTimeouts.forEach((id) => clearTimeout(id));
      }
      this._scrollToTodayTimeouts = [];

      const today = dayjs().format("YYYY-MM-DD"); // Get today's date in YYYY-MM-DD format
      const todayIndex = this.minsData.weekDays.findIndex(
        (day) => dayjs(day.date).format("YYYY-MM-DD") === today,
      );

      if (todayIndex !== -1) {
        // Use setTimeout to ensure DOM is fully rendered
        const timeoutId = setTimeout(() => {
          const todayColumn = document.querySelectorAll(
            ".mins-stats-col-day-wrapper",
          )[todayIndex];

          const eventsContainer = document.querySelector(".events");

          if (todayColumn && eventsContainer) {
            // Calculate the position to scroll to center the column
            const columnOffsetLeft = todayColumn.offsetLeft;
            const containerWidth = eventsContainer.clientWidth;
            const columnWidth = todayColumn.offsetWidth;

            // Calculate scroll position to center the column
            const scrollLeft =
              columnOffsetLeft - containerWidth / 2 + columnWidth / 2;

            // Scroll the container to center the today column
            eventsContainer.scrollTo({
              left: Math.max(0, scrollLeft),
              behavior: "smooth",
            });
          }
        }, 300); // Wait 300ms for DOM to be fully rendered
        this._scrollToTodayTimeouts.push(timeoutId);
      } else {
        console.log("Today's date is not in the current view.");
        // Change the month to include today's date
        const currentYear = Number(dayjs().format("YYYY"));
        const currentMonth = Number(dayjs().format("M")) - 1; // Month is 0-indexed
        this.minsData.weekDays = this.populateMinsCal(
          currentYear,
          currentMonth,
          "minsData",
        );

        // Update the schedule start and end dates
        const currentDate = `${currentYear}-${currentMonth + 1}-01`;
        this.scheduleStartDate = moment(currentDate)
          .subtract(1, "months")
          .format("YYYY-MM-DD");
        this.scheduleEndDate = moment(currentDate)
          .add(2, "months")
          .format("YYYY-MM-DD");

        // Fetch the updated events
        this.getAllGamesEventsByClubId();

        // Scroll to today after updating the calendar
        const timeoutId = setTimeout(() => {
          const updatedTodayIndex = this.minsData.weekDays.findIndex(
            (day) => dayjs(day.date).format("YYYY-MM-DD") === today,
          );

          if (updatedTodayIndex !== -1) {
            const updatedTodayColumn = document.querySelectorAll(
              ".mins-stats-col-day-wrapper",
            )[updatedTodayIndex];

            const eventsContainer = document.querySelector(".events");

            if (updatedTodayColumn && eventsContainer) {
              const columnOffsetLeft = updatedTodayColumn.offsetLeft;
              const containerWidth = eventsContainer.clientWidth;
              const columnWidth = updatedTodayColumn.offsetWidth;

              const scrollLeft =
                columnOffsetLeft - containerWidth / 2 + columnWidth / 2;

              eventsContainer.scrollTo({
                left: Math.max(0, scrollLeft),
                behavior: "smooth",
              });
            }
          }
        }, 500); // Give more time for data loading and DOM updates
        this._scrollToTodayTimeouts.push(timeoutId);
      }
    },
    getDayAndDate(date) {
      return moment(date).format("dddd, MMMM Do YYYY");
    },
    editOtherEvent(eventData) {
      this.editOtherEventData = eventData;
      this.showEditOtherEventModal = true;
    },
    produceTheAcademySchedulePDF() {
      setTimeout(() => {
        let pdf = this.buildTheAcademySchedulePDF();
        pdf.previewLink.src = pdf.pdfData.output("datauristring");
        this.$toast.info("Schedule PDF ready in the preview below.", {
          title: "Generated",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }, 500);
    },
    base64SvgToBase64Png(originalBase64, width) {
      return new Promise((resolve) => {
        let img = document.createElement("img");
        img.onload = function () {
          document.body.appendChild(img);
          let canvas = document.createElement("canvas");
          let ratio = img.clientWidth / img.clientHeight || 1;
          document.body.removeChild(img);
          canvas.width = width;
          canvas.height = width / ratio;
          let ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          try {
            let data = canvas.toDataURL("image/png");
            resolve(data);
          } catch (e) {
            resolve(null);
          }
        };
        img.onerror = function () {
          resolve(null);
        };
        img.src = originalBase64;
      });
    },
    buildTheAcademySchedulePDF() {
      let previewContainer = document.getElementById(
        "theAcademySchedulePdf_preview",
      );
      let pdf = new JsPDF("l", "mm", "a4");
      let img = document.getElementById("png-logo");
      pdf.addImage(img, "PNG", 5, 2, 15, 15);

      pdf.setFontSize(16).setFont(undefined, "bold");
      pdf.text(25, 10, `${getTenantName()} academy training programme`);

      pdf.setFontSize(12);
      pdf.text(
        25,
        16,
        `${this.formatDateForDayMonth(
          this.printScheduleData.weekStartDate,
        )} - ${this.formatDateForDayMonth(this.printScheduleData.weekEndDate)}`,
      );

      pdf.setFontSize(9);
      pdf.text(8, 26, "Age group");

      pdf.text(38, 26, "Monday");

      pdf.text(75, 26, "Tuesday");

      pdf.text(110, 26, "Wednesday");

      pdf.text(145, 26, "Thursday");

      pdf.text(180, 26, "Friday");

      pdf.text(215, 26, "Saturday");

      pdf.text(250, 26, "Sunday");

      this.pageLines(pdf, true);

      const academyScheduleDataToPopulate = this.populateTheAcademySchedule();
      this.populateTeamsAcademyScheduleData(academyScheduleDataToPopulate, pdf);

      return { pdfData: pdf, previewLink: previewContainer };
    },
    populateTeamsAcademyScheduleData(academyScheduleDataToPopulate, pdf) {
      let marginTop = 45;

      // Mapping of days to their horizontal positions
      const dayPositions = {
        Monday: 35,
        Tuesday: 70,
        Wednesday: 105,
        Thursday: 140,
        Friday: 175,
        Saturday: 210,
        Sunday: 245,
      };

      this.clubTeams.forEach((team) => {
        // ignore  St John's pitch +  Harp / Beechwood Park for Dundee
        if (
          team.teamName !== "St John's pitch" &&
          team.teamName !== "Harp / Beechwood Park" &&
          team.teamName !== "DFC performance school"
        ) {
          // Reset font style and check for page space
          pdf.setFontSize(7).setFont(undefined, "normal");
          pdf.setTextColor(64, 52, 54);
          pdf.setDrawColor(113, 113, 113);
          marginTop = this.newPageCheck(marginTop, null, pdf);

          // Group events by day for this team
          const eventsByDay = {};
          if (academyScheduleDataToPopulate.length > 0) {
            academyScheduleDataToPopulate.forEach((scheduleDataToPopulate) => {
              if (team.teamName === scheduleDataToPopulate.team) {
                const schedule = scheduleDataToPopulate.schedule;
                const day = moment(schedule.date, "YYYY-MM-DD").format("dddd");

                if (!eventsByDay[day]) {
                  eventsByDay[day] = [];
                }
                eventsByDay[day].push(schedule);
              }
            });
          }

          // Calculate the maximum number of events in any day for this team
          const maxEventsInDay = Math.max(
            1,
            ...Object.values(eventsByDay).map((events) => events.length),
          );
          const rowHeight = Math.max(14, maxEventsInDay * 7); // 7mm per event, minimum 14mm

          // Print team name
          pdf.text(6, marginTop, team.teamName, { maxWidth: 27 });

          // Helper function to add text to PDF
          const addScheduleText = (x, y, time, title) => {
            pdf.setFontSize(7).setFont(undefined, "bold");
            pdf.text(x, y, time);
            pdf.setFontSize(6).setFont(undefined, "normal");
            pdf.text(x, y + 2.5, title, { maxWidth: 28 });
          };

          // Draw events for each day
          Object.keys(eventsByDay).forEach((day) => {
            if (dayPositions[day]) {
              const xPosition = dayPositions[day];
              const events = eventsByDay[day];

              // Draw each event, stacking them vertically if multiple
              events.forEach((schedule, eventIndex) => {
                const yOffset = eventIndex * 7; // 7mm spacing between events
                const yPosition = marginTop + yOffset;

                // Set color based on game type
                if (schedule.gameType === "League game") {
                  pdf.setTextColor(29, 164, 79);
                } else if (schedule.gameType === "Training") {
                  pdf.setTextColor(20, 132, 151);
                } else if (schedule.gameType === "Cup game") {
                  pdf.setTextColor(103, 81, 6);
                } else if (schedule.gameType === "Other") {
                  pdf.setTextColor(45, 6, 103);
                }

                addScheduleText(
                  xPosition,
                  yPosition,
                  schedule.time,
                  schedule.title,
                );
                pdf.setTextColor(100);
              });
            }
          });

          // Add spacing for the next team and draw a line
          marginTop += rowHeight;
          pdf.line(5, marginTop - 3, 285, marginTop - 3);
        }
      });
      // Add final bottom spacing to prevent last team cut-off
      marginTop += 8;
      pdf.setDrawColor(113, 113, 113);
      pdf.line(5, marginTop, 285, marginTop);
    },
    pageLines(pdf, topLine) {
      let marginTop = 0;
      if (topLine === true) {
        marginTop = 22;
        pdf.line(5, 22, 285, 22); // top
        pdf.line(5, 30, 285, 30); // header separator line
      } // bottom

      pdf.setLineWidth(0.2);
      //outerlines with optimized column widths
      pdf.line(5, 280, 5, marginTop); // left boundary
      pdf.line(32, 280, 32, marginTop); // team name column
      pdf.line(67, 280, 67, marginTop); // Monday
      pdf.line(102, 280, 102, marginTop); // Tuesday
      pdf.line(137, 280, 137, marginTop); // Wednesday
      pdf.line(172, 280, 172, marginTop); // Thursday
      pdf.line(207, 280, 207, marginTop); // Friday
      pdf.line(242, 280, 242, marginTop); // Saturday
      pdf.line(285, 280, 285, marginTop); // right boundary
    },
    newPageCheck(height, dynamicHeight, pdf) {
      if (height >= 270) {
        pdf.addPage();
        this.pageLines(pdf);
        return 10;
      } else {
        //height = Math.round(dynamicHeight.h + height + 10);
        return height;
      }
    },
    selectedWeekDatesFormat() {
      const startOfWeek = moment().startOf("isoweek");
      const result = [];

      for (let i = 0; i < 7; i++) {
        result.push(startOfWeek.clone().add(i, "days").format("YYYY-MM-DD"));
      }

      return result;
    },
    populateTheAcademySchedule() {
      const selectedWeekDates = this.selectedWeekDatesFormat();
      const academySchedule = [];

      this.clubTeams.forEach((team) => {
        selectedWeekDates.forEach((date) => {
          this.scheduleData.forEach((schedule) => {
            if (schedule.date === date) {
              if (Number(team.id) === Number(schedule.teamId)) {
                academySchedule.push({
                  schedule: schedule,
                  team: team.teamName,
                });
              }
            }
          });
        });
      });

      return academySchedule;
    },
    async getSelectedTeamsEvents(startDate, endDate) {
      this.loadingStuff = true;
      // Guard against junk dates (e.g. moment's "Invalid date") reaching the
      // backend, where new DateTime() would throw a fatal on PHP 8.3.
      const safeDate = (v) =>
        v && String(v).trim().toLowerCase() !== "invalid date" &&
        !isNaN(new Date(v).getTime())
          ? v
          : null;
      const data = {
        action: "getAllGamesEventsById",
        teamId: this.selectedTeam.id,
        gameFromDate: safeDate(startDate),
        gameToDate: safeDate(endDate),
      };
      const responce = await Games.find(data).catch((error) => {
        console.log(error);
      });
      this.selectedGamesEvents = responce.data;
      this.loadingStuff = false;
    },
    dateRangeSelected() {
      this.getSelectedTeamsEvents(
        this.formatMatchDate(this.dateRange.startDate),
        this.formatMatchDate(this.dateRange.endDate),
      );
    },
    async getgadyflLeagueTableData() {
      const data = {
        action: "getAllOppositionTeams",
      };

      const responce = await Games.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.leagueTeams = responce.data;
      }
    },
    formatMatchDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    setSelectedTeam(e) {
      const teamData = e.target.value;

      let selectedTeamData = this.clubTeams.filter(function (team) {
        return team.teamName === teamData;
      });

      this.selectedTeam = selectedTeamData[0];
      // Don't clobber a past-season override (set by the global season selector).
      if (!localStorage.getItem("selectedSeasonYear")) {
        localStorage.setItem(
          "currentPlayingseasonStartDate",
          this.selectedTeam.season_start_date,
        );
        localStorage.setItem(
          "currentPlayingseasonEndDate",
          this.selectedTeam.season_end_date,
        );
      }
    },
    async sendFBNotificationMessage(title, body, ageGroup) {
      const data = {
        action: "sendFBNotificationMessage",
        title: title,
        body: body,
        link: `${window.location.origin}/login`,
        age_group: ageGroup,
        clubId: this.userData.clubId,
      };
      const responce = await Chat.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.$toast.info("Notification sent", {
          title: "Notification sent",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    // -------- Time-storage contract (booking schedule) --------
    // Times are stored as wall-clock UTC strings (`YYYY-MM-DDTHH:MM:00.000Z`).
    // This is NOT a true UTC timestamp — the `Z` suffix is intentional so
    // every read site can use `moment(...).utc()` to display the same
    // wall-clock value regardless of the viewer's timezone.
    //
    // If you ever read these fields without `.utc()`, the displayed time
    // will shift by the viewer's TZ offset and break for users abroad.
    // Likewise, do not migrate stored values to ISO-with-offset without
    // updating every read site at the same time — historical rows assume
    // this contract.
    // -----------------------------------------------------------
    changeTimeToTimeAndDate(timeString, date) {
      return `${date}T${timeString}:00.000Z`;
    },
    formatISOStringDateAndTime(timeDateString) {
      return moment(timeDateString).utc().format("h:mm a");
    },
    converTimesForDB(objectName) {
      if (this[objectName].endTime !== "") {
        this[objectName].endTime = this.changeTimeToTimeAndDate(
          this[objectName].endTime,
          this.formatMatchDate(this[objectName].matchDate),
        );
      }

      if (this[objectName].meetTime !== "") {
        this[objectName].meetTime = this.changeTimeToTimeAndDate(
          this[objectName].meetTime,
          this.formatMatchDate(this[objectName].matchDate),
        );
      }

      if (this[objectName].kickOffTime !== "") {
        this[objectName].kickOffTime = this.changeTimeToTimeAndDate(
          this[objectName].kickOffTime,
          this.formatMatchDate(this[objectName].matchDate),
        );
      }

      if (this[objectName].matchDate !== "") {
        this[objectName].matchDate = this.formatMatchDate(
          this[objectName].matchDate,
        );
      }
    },
    async addEditProgrammeSubmit() {
      this.loadIngStuffText = "Saving";
      this.loadingStuff = true;
      this.showAddEditGamesModal = false;
      this.converTimesForDB("newGameData");
      const action = { action: "saveNewGame" };
      this.newGameData.home_team === true
        ? (this.newGameData.home_team = 1)
        : (this.newGameData.home_team = 0);

      this.newGameData.teamId = this.selectedTeam.id;
      this.newGameData.teamName = this.selectedTeam.teamName;

      const data = {
        ...this.newGameData,
        ...action,
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      const responce = await Games.find(data).catch((error) => {
        console.log(error);
      });

      if (responce && responce.data && responce.data.message === "Game added.") {
        this.getAllGamesEventsByClubId();
        //this.getSelectedTeamsEvents(this.formatMatchDate(this.dateRange.startDate),this.formatMatchDate(this.dateRange.endDate));
        this.loadingStuff = false;
        let body = "";
        if (this.newGameData.gameType !== "Training") {
          body = `${this.newGameData.gameType} vs ${this.newGameData.opposition}. Kickoff: ${this.formatISOStringDateAndTime(this.newGameData.kickOffTime)} Meet: ${this.formatTime(this.newGameData.meetTime)} Venue: ${this.newGameData.locationName} ${this.newGameData.address} ${this.newGameData.postCode}`;
        } else {
          body = `${this.newGameData.gameType} Kickoff: ${this.formatISOStringDateAndTime(this.newGameData.kickOffTime)} Venue: ${this.newGameData.locationName} ${this.newGameData.address} ${this.newGameData.postCode}`;
        }
        this.sendFBNotificationMessage(this.newGameData.gameType, body, [
          this.selectedTeam.age_group,
        ]);
      }
    },
    changeTimeFrom24To12jours(time) {
      let hours = time.substr(0, 2);
      let mins = time.substr(3, 2);
      var AmOrPm = hours >= 12 ? "pm" : "am";
      hours = hours % 12 || 12;

      return `${hours}:${mins} ${AmOrPm}`;
    },
    async getEvents() {
      this.scheduleDatesDefault();
      const data = {
        action: "getEvents",
        season_start_date: this.scheduleStartDate,
        season_end_date: this.scheduleEndDate,
      };

      const responce = await Teams.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        if (responce.data.length > 0) {
          responce.data.map((item) => {
            this.scheduleData.push({
              title: item.title,
              date: item.date,
              time: item.start_time,
              endTime: item.end_time,
              teamId: item.teamId.toString(),
              pitch_zone: "",
              gameType: "Other",
              eventId: item.id,
            });
          });

          this.setSchedulerTableCellHeight();
        }
      }
    },
    setSchedulerTableCellHeight() {
      const baseHeight = 80; // px per event
      const minHeight = 80; // px minimum height

      // Get all team name cells (excluding the header "Team" cell)
      const teamNameCells = Array.from(
        document.querySelectorAll(".col-one-teams .body"),
      ).slice(1); // Skip first cell which is the header

      // Get all day columns
      const dayColumns = Array.from(
        document.querySelectorAll(".mins-stats-col-day-wrapper"),
      );

      this.clubTeams.forEach((team, teamIndex) => {
        let maxHeight = minHeight;

        // Find the max height needed for this team across all days
        this.minsData.weekDays.forEach((day) => {
          if (day.date) {
            const formattedDate = dayjs(day.date).format("YYYY-MM-DD");
            const eventsForCell = this.scheduleData.filter(
              (event) =>
                event.date === formattedDate &&
                String(event.teamId) === String(team.id),
            );
            const cellHeight = Math.max(
              minHeight,
              baseHeight * eventsForCell.length,
            );
            if (cellHeight > maxHeight) maxHeight = cellHeight;
          }
        });

        // Set height on team name cell
        if (teamNameCells[teamIndex]) {
          teamNameCells[teamIndex].style.height = `${maxHeight}px`;
          teamNameCells[teamIndex].style.minHeight = `${maxHeight}px`;
        }

        // Set height on all event cells for this team across all days
        dayColumns.forEach((dayColumn) => {
          // Get all body cells in this day column (excluding header)
          const bodyCells = Array.from(dayColumn.querySelectorAll(".body"));
          // The teamIndex corresponds to the position in bodyCells
          if (bodyCells[teamIndex]) {
            bodyCells[teamIndex].style.height = `${maxHeight}px`;
            bodyCells[teamIndex].style.minHeight = `${maxHeight}px`;
          }
        });
      });
    },
    async saveEvent() {
      this.newEventData.date = this.formatDateForDB(this.newEventData.date);
      const data = {
        action: "saveEvent",
        listOfSelectedYear: this.listOfSelectedYear,
        ...this.newEventData,
        seasion_end_date: this.extendSeasonEndDateToFullYear(),
      };

      const responce = await Teams.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.getAllGamesEventsByClubId();
        this.newEventData = {};
        ((this.listOfSelectedYear = []),
          (this.listOfSelectedYearToRemove = []),
          (this.showAddEventModal = false));
        this.$toast.info("Event saved", {
          title: "Saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async editOtherEventCall() {
      this.editOtherEventData.date = this.formatDateForDB(
        this.editOtherEventData.date,
      );
      const data = {
        action: "editOtherEvent",
        listOfSelectedYear: this.listOfSelectedYear,
        ...this.editOtherEventData,
      };

      const responce = await Teams.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.getAllGamesEventsByClubId();
        this.newEventData = {};
        ((this.listOfSelectedYear = []),
          (this.listOfSelectedYearToRemove = []));
        this.showEditOtherEventModal = false;
        this.$toast.info("Event updated", {
          title: "Saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    confirmDeleteOtherEvent() {
      const title = this.editOtherEventData?.title || "this event";
      if (
        window.confirm(
          `Delete "${title}"? This cannot be undone.`,
        )
      ) {
        this.deleteOtherEventCall();
      }
    },
    async deleteOtherEventCall() {
      const data = {
        action: "deleteOtherEvent",
        eventId: this.editOtherEventData.eventId,
      };

      const responce = await Teams.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.getAllGamesEventsByClubId();
        this.newEventData = {};
        ((this.listOfSelectedYear = []),
          (this.listOfSelectedYearToRemove = []));
        this.showEditOtherEventModal = false;
        this.$toast.info("Event removed", {
          title: "Saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    ageGroupAddRemove(data) {
      data.target.checked === true
        ? this.addToListOfSelectedTeamAgeGroups(data.target.value)
        : this.removeFromListOfSelectedAgeGroups(data.target.value);
    },
    removeFromListOfSelectedAgeGroups(year) {
      this.listOfSelectedYear = this.listOfSelectedYear.filter(
        (item) => item !== year,
      );
    },
    addToListOfSelectedTeamAgeGroups(year) {
      if (!this.listOfSelectedYear.includes(year)) {
        this.listOfSelectedYear.push(year);
      }
    },
    openAddEventModal() {
      this.showAddEventModal = true;
    },
    tabChange(tabValue, selectedTabValue) {
      this[tabValue] = selectedTabValue;
    },
    changeMonth(value, dataType) {
      let changeNumber = 0;
      let yearNumber = this[dataType].year;

      if (value === 1) {
        changeNumber = Number(dayjs().month(this[dataType].month).format("M"));
        if (this[dataType].month === 11) {
          changeNumber = 0;
          yearNumber = dayjs().year(yearNumber).add(1, "year").format("YYYY");
        }
      } else {
        changeNumber = Number(
          dayjs().month(this[dataType].month).subtract(2, "month").format("M"),
        );

        if (this[dataType].month === 1) {
          changeNumber = 0;
          yearNumber = dayjs().year(yearNumber).format("YYYY");
        }

        if (this[dataType].month === 0) {
          yearNumber = dayjs()
            .year(yearNumber)
            .subtract(1, "year")
            .format("YYYY");
        }
      }

      this[dataType].weekDays = this.populateMinsCal(
        Number(yearNumber),
        Number(changeNumber),
        dataType,
      );

      if (changeNumber === 0) {
        changeNumber = 1;
      }

      const currentDate = `${yearNumber}-${changeNumber}-01`;

      this.scheduleStartDate = moment(currentDate)
        .subtract(1, "months")
        .format("YYYY-MM-DD");
      this.scheduleEndDate = moment(currentDate)
        .add(2, "months")
        .format("YYYY-MM-DD");

      this.getAllGamesEventsByClubId();
    },
    formatDateForDB(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    formatDateForHuman(date) {
      return date !== undefined && moment(date).isValid()
        ? moment(date).format("MMMM Do YYYY")
        : "";
    },
    formatDateForHumanShort(date) {
      return date !== undefined && moment(date).isValid()
        ? moment(date).format("MMMM Do, h:mm a")
        : "";
    },
    formatTime(date) {
      return date !== undefined && moment(date).isValid()
        ? moment(date).utc().format("h:mm a")
        : "";
    },
    formatDateForDayMonth(date) {
      return moment(date).format("dddd Do MMMM");
    },
    populateScheduleDay() {
      this.scheduleData = [];
      if (!Array.isArray(this.teamGamesDataUnfilterded)) {
        this.teamGamesDataUnfilterded = [];
      }
      this.teamGamesDataUnfilterded.map((game) => {
        let title = "";
        let time = "";
        let pitch_zone = null;
        let location = "";

        if (game.gameType !== "Training") {
          title = `Vs ${game.opposition}`;
          time = `${this.formatTime(game.kickOffTime)} KO `;
          location = `At ${game.locationName}`;
        } else {
          title = `${game.gameType}`;
          time = `${this.formatTime(game.kickOffTime)} - ${this.formatTime(
            game.endTime,
          )}`;
          pitch_zone = game.pitch_zone;
          location = `At ${game.locationName}`;
        }

        this.scheduleData.push({
          title: title,
          date: game.matchDate,
          meetTime: this.formatTime(game.meetTime),
          time: time,
          teamId: game.teamId,
          pitch_zone: pitch_zone,
          gameType: game.gameType,
          location: location,
          postCode: game.postCode,
          id: game.id,
          opposition: game.opposition,
          kickOffTime: game.kickOffTime,
          matchDate: game.matchDate,
          locationName: game.locationName,
          address: game.address,
          stripType: game.stripType,
          notes: game.notes,
          teamName: game.teamName,
          pitchType: game.pitchType,
          endTime: game.endTime,
          recurringEventType: game.recurringEventType,
          result_added: game.result_added,
          home_team_goals: game.home_team_goals,
          away_team_goals: game.away_team_goals,
          home_team_goal_scorers: game.home_team_goal_scorers,
          away_team_goal_scorers: game.away_team_goal_scorers,
          pitch_id: game.pitch_id,
          going: game.going || 0,
          injured: game.injured || 0,
          noResponse: game.noResponse || 0,
          notGoing: game.notGoing || 0,
          userImage: game.userImage || "",
          userName: game.userName || "",
        });
      });

      if (this.userData.userType !== "User") {
        this.getEvents();
      }
      this.$nextTick(() => this.setSchedulerTableCellHeight());
    },
    scheduleDatesDefault() {
      if (this.scheduleStartDate === "" || this.scheduleEndDate === "") {
        this.scheduleStartDate = moment()
          .subtract(1, "months")
          .format("YYYY-MM-DD");
        this.scheduleEndDate = moment().add(2, "months").format("YYYY-MM-DD");
      }
    },
    async getAllAttendanceForUser(season_start_date, season_end_date) {
      let data = {
        userId: this.userData.id,
        action: "getAllAttendanceForUser",
        season_start_date: season_start_date,
        season_end_date: season_end_date,
      };
      const response = await Games.find(data).catch((error) => {
        console.log(error);
      });
      if (response.status === 200) {
        this.selectedPlayerAttendanceData = response.data;
      }
    },
    // Add this method to your component
    mergeAttendanceData() {
      // Defensive: drop any null/undefined entries before mapping. A single
      // null game in the array would otherwise blow up the whole list.
      this.teamGamesDataUnfilterded = (
        this.teamGamesDataUnfilterded || []
      )
        .filter(Boolean)
        .map((game) => {
          // Find matching attendance record by kickOffTime and teamId
          const attendanceRecord = (
            this.selectedPlayerAttendanceData || []
          ).find(
            (attendance) =>
              attendance &&
              attendance.kickOffTime === game.kickOffTime &&
              String(attendance.teamId) === String(game.teamId),
          );

          // If match found, add attendance properties to the game object
          if (attendanceRecord) {
            console.log(
              "Merging attendance for game:",
              game,
              "with record:",
              attendanceRecord,
            );
            return {
              ...game,
              going: attendanceRecord.going,
              injured: attendanceRecord.injured,
              noResponse: attendanceRecord.noResponse,
              notGoing: attendanceRecord.notGoing,
              userImage: attendanceRecord.userImage,
              userName: attendanceRecord.userName,
            };
          }

          // If no match, return original game object
          return game;
        });

      // Re-populate scheduleData with the merged attendance data
      this.populateScheduleDay();
    },
    async getAllGamesEventsByClubId() {
      if (this.clubTeams.length === 0) {
        await this.getTeamsByUserId();
      }
      this.scheduleDatesDefault();
      let data = {
        season_start_date: this.scheduleStartDate,
        season_end_date: this.scheduleEndDate,
        action: "getAllGamesEventsByClubId",
      };

      if (this.userData.userType === "User") {
        data.action = "getAllGamesEventsByTeamId";
        data.teamId = this.userData.teamId;

        await this.getAllAttendanceForUser(
          this.scheduleStartDate,
          this.scheduleEndDate,
        );
      }

      if (this.userData.userType === "Coach") {
        // For coaches, get games for all their teams
        console.log("Club teams for coach:", this.clubTeams);
        const teamIds = this.clubTeams.map((team) => team.teamId);
        data.teamIds = teamIds;
        data.action = "getAllGamesEventsByTeamIds";
      }

      const responce = await Games.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.teamGamesDataUnfilterded = responce.data;
        this.teamGamesData = responce.data;

        // Merge attendance data if user type is "User"
        if (this.userData.userType === "User") {
          this.mergeAttendanceData(); // This now calls populateScheduleDay()
        } else {
          this.populateScheduleDay(); // Only call if not merging attendance
        }
      }
    },
    async getUserById(clientId) {
      const userData = {
        clientId: clientId,
        action: "getUserByID",
      };
      const responce = await Users.find(userData).catch((error) => {
        console.log(error);
      });
      if (responce.data.length > 0) {
        this.userData = responce.data[0];
        await Promise.all([
          this.getTeamsByUserId(),
          this.getAllPitchesForClub(),
          this.getgadyflLeagueTableData(),
          this.getAllGamesEventsByClubId(),
        ]);
      }
    },
    async setUser() {
      if (this.getProfile !== null) {
        this.userData = this.getProfile;
        await Promise.all([
          this.getTeamsByUserId(),
          this.getAllPitchesForClub(),
          this.getgadyflLeagueTableData(),
        ]);
      }
    },
    populateMinsCal(year, month, dataType) {
      this[dataType].year = year;
      this[dataType].month = month;
      let date = new Date(year, month, 1);
      let dates = [];

      while (date.getMonth() === month) {
        const entry = {
          date: new Date(date),
          id: null,
        };

        if (dataType === "minsData") {
          entry.minsTotal = null;
        }

        dates.push(entry);
        date.setDate(date.getDate() + 1);
      }

      return dates;
    },
    getMonthName(dateNumber) {
      return dayjs().month(dateNumber).format("MMMM");
    },
    getDayFromDate(date) {
      return dayjs(date).format("ddd D");
    },
    async getTeamsByUserId() {
      const data = {};

      if (this.userData.userType === "Coach") {
        data.action = "getTeamsByCoachid";
        data.coach_id = this.userData.id;
      } else {
        data.action = "getTeamsDataById";
        data.userId = this.userData.id;
        data.clubId = this.userData.clubId;
      }

      const response = await Teams.find(data).catch((error) => {
        console.log(error);
      });
      this.allTeamDataBeforFilterApplied = response.data;
      // Sort teams by age group (youngest to oldest)
      const sortedTeams = response.data.sort((a, b) => {
        const getBirthYear = (ageGroup) => {
          if (!ageGroup) return 0; // Put teams without age_group at the end
          const match = ageGroup.match(/U?(\d+)/i);
          return match ? parseInt(match[1]) : 0;
        };
        const birthYearA = getBirthYear(a.age_group);
        const birthYearB = getBirthYear(b.age_group);
        console.log(
          `Comparing ${a.teamName} (birth year: ${birthYearA}) vs ${b.teamName} (birth year: ${birthYearB})`,
        );
        // Since birth years work inversely (higher year = younger player), we sort in descending order to get youngest first
        return birthYearB - birthYearA;
      });

      // Filter teams for regular users to show only their assigned team
      if (this.userData.userType === "User" && this.userData.teamId) {
        this.clubTeams = sortedTeams.filter(
          (team) => String(team.id) === String(this.userData.teamId),
        );
        if (this.clubTeams.length > 0) {
          this.selectedTeam = this.clubTeams[0];
        }
      } else {
        // Admins and Coaches see all teams
        this.clubTeams = sortedTeams;
        this.selectedTeam = sortedTeams[0];
      }

      // Add extra teams at the end (only for Admins and Coaches)
      if (this.userData.userType !== "User" && getTenantId() === "dfc") {
        this.clubTeams.push({
          id: 1002,
          teamId: 1002,
          teamName: "DFC Performance School",
          age_group: null,
        });
      }
      if (this.userData.userType !== "User") {
        this.clubTeams.push({
          id: 1000,
          teamId: 1000,
          teamName: "GK",
          age_group: null, // No age group for sorting
        });
      }
    },
    showPrintScheduleModal() {
      this.printScheduleData = {
        weekStartDate: moment().startOf("isoweek"),
        weekEndDate: moment(moment().startOf("isoweek")).add(6, "days"),
        clubTeams: this.clubTeams,
      };
      this.showPrintScheduleModalVisible = true;
    },
    showAddGamesModal() {
      this.showTeamChange = false;
      this.emptyNewGameData();
      let today = moment();
      this.weeklyDate = today._d;
      this.showAddEditGamesModal = true;
    },
    setFirstTeamNameAndId() {
      this.newGameData.teamName = this.clubTeams[0].teamName;
      this.newGameData.teamId = this.clubTeams[0].teamId;
    },
    emptyNewGameData() {
      this.newGameData = {
        opposition: "",
        kickOffTime: "",
        matchDate: "",
        locationName: "",
        address: "",
        postCode: "",
        stripType: "",
        meetTime: "",
        endTime: "",
        notes: "",
        gameType: "Training",
        teamId: "",
        teamName: "",
        pitchType: "",
        recurringEventType: null,
        home_team_goals: 0,
        away_team_goals: 0,
        away_team_goal_scorers: null,
        home_team_goal_scorers: null,
        result_added: 0,
        pitch_id: "",
        pitch_zone: null,
        home_team: false,
      };
      this.setFirstTeamNameAndId();
    },
    setPitchZones(pitchData, gameDataType) {
      if (
        pitchData.sectionOne !== false &&
        pitchData.sectionTwo === false &&
        pitchData.sectionThree === false
      ) {
        this[gameDataType].pitch_zone = "1";
      } else if (
        pitchData.sectionTwo !== false &&
        pitchData.sectionOne === false &&
        pitchData.sectionThree === false
      ) {
        this[gameDataType].pitch_zone = "2";
      } else if (
        pitchData.sectionThree !== false &&
        pitchData.sectionOne === false &&
        pitchData.sectionTwo === false
      ) {
        this[gameDataType].pitch_zone = "3";
      } else if (
        pitchData.sectionOne !== false &&
        pitchData.sectionTwo === false &&
        pitchData.sectionThree !== false
      ) {
        this[gameDataType].pitch_zone = "1,3";
      } else if (
        pitchData.sectionTwo !== false &&
        pitchData.sectionThree !== false &&
        pitchData.sectionOne === false
      ) {
        this[gameDataType].pitch_zone = "2,3";
      } else if (
        pitchData.sectionOne !== false &&
        pitchData.sectionThree === false &&
        pitchData.sectionTwo !== false
      ) {
        this[gameDataType].pitch_zone = "1,2";
      }
    },
    pitchChange(pitchData, gameType) {
      if (this.newGameData.matchDate !== "" || this.editGame.matchDate !== "") {
        if (this.newGameData.matchDate !== "") {
          this.setPitchZones(pitchData, "newGameData");
        }
      }
      this[gameType].pitch_id = pitchData.pitchId || pitchData.id;
      const pitch = this.pitches.filter(
        (pitch) => pitch.id == pitchData.pitchId,
      );
      this[gameType].address = pitch[0].address;
      this[gameType].locationName = pitch[0].name;
      this[gameType].postCode = pitch[0].postCode;
      this[gameType].pitchType = pitch[0].pitchType;
      this.togglePitchDetails = true;
    },
    async getAllPitchesForClub() {
      const userData = {
        clubId: this.userData.clubId,
        action: "getAllPitchesForClub",
      };
      const responce = await Pitches.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.pitches = responce.data;
      }
    },
    populateFirstTeamSelectedData(gameType) {
      // This method handles the change when a game type is selected
      if (gameType === "Training") {
        this.showTeamChange = false;
      } else {
        this.showTeamChange = true;
      }
    },
    toggleRecurringEvent() {
      // Toggle the recurring event state
      // This method is called when the recurring event checkbox is changed
      if (!this.recurringEvent) {
        this.newGameData.recurringEventType = null;
      }
    },
    populateSelectedTeamVenue(teamId, gameDataType) {
      // This method populates the venue information when an opposition team is selected
      if (this.leagueTeams && this.leagueTeams.length > 0) {
        const selectedTeam = this.leagueTeams.find(
          (team) => team.id === parseInt(teamId),
        );
        if (selectedTeam && gameDataType === "newGameData") {
          this.newGameData.locationName = selectedTeam.venue || "";
          this.newGameData.address = selectedTeam.address || "";
          this.newGameData.postCode = selectedTeam.postCode || "";
          this.newGameData.opposition = selectedTeam.teamName || "";
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
// Standard filter-row pattern shared with leads / games / trialists tabs.
.lead-tabs-filters {
  margin: 1rem 0 0.75rem;
}

.lead-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem 1rem;

  .filter-group {
    display: flex;
    flex-direction: column;
    min-width: 180px;
    flex: 0 1 auto;
  }

  .filter-label {
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #6c757d;
    margin-bottom: 0.25rem;
  }

  .filter-select {
    height: 38px;
    padding: 0.375rem 2rem 0.375rem 0.75rem;
    font-size: 0.9rem;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    border: 1px solid #ced4da;
    border-radius: 6px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    &:hover { border-color: #adb5bd; }
    &:focus {
      border-color: #80bdff;
      outline: 0;
      box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.15);
    }
  }

  .filter-reset {
    height: 38px;
    padding: 0 0.85rem;
    font-size: 0.85rem;
    color: #6c757d;
    background: transparent;
    border: 1px solid #ced4da;
    border-radius: 6px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    align-self: flex-end;
    transition: background 0.15s, border-color 0.15s, color 0.15s;

    &:hover {
      background: #f8f9fa;
      border-color: #adb5bd;
      color: #212529;
    }
  }
}

.leads-count {
  font-size: 0.85rem;
  color: #6c757d;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

// Attendance response pills
.attendance-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 600;

  &.going {
    background: #d1e7dd;
    color: #0a3622;
  }

  &.not-going {
    background: #f8d7da;
    color: #58151c;
  }

  &.injured {
    background: #fff3cd;
    color: #664d03;
  }
}

.automatic-comments {
  ul {
    display: flex;
    gap: 0.5rem;
    padding: 0;
    text-align: center;
    list-style: none;
    margin: 0 0 1rem 0;
  }

  li {
    border: 1px solid #dddddd;
    padding: 0.3rem;
    border-radius: 10px;
    cursor: pointer;

    &:hover,
    &.active {
      background-color: #f0f0f0;
    }
  }
}

.player-list {
  li {
    margin: 0;
    padding: 0.5rem 0;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 1rem;

    &:last-child {
      border-bottom: none;
    }

    img.user-image-small {
      margin: 0;
      width: 3rem;
      height: 3rem;
    }

    .player-comment {
      font-size: 0.9rem;
      color: #666;
      background: #f2f4f7;
      padding: 1rem;
      display: block;
      border-radius: 4px;
    }
  }
}

h2.small-title {
  text-transform: none;
  font-size: 1.1rem;
  font-weight: bold;
}

.match-details {
  .details {
    display: flex;
    gap: 1rem;
    margin-bottom: 0.5rem;

    .date-times-wrapper {
      width: 100%;
    }

    .header-text-bold {
      font-weight: bold;
    }

    i {
      height: 3rem;
      width: 2rem;
      display: block;
    }

    .times-wrapper {
      font-size: 0.8rem;
    }
  }

  a.map-link {
    display: block;
    border: none;
    padding: 0;

    .map-icon-text {
      display: flex;
      gap: 0.3rem;
    }
  }
}

.recurring-event-checkBox-class {
  border: 1px solid #059e53;
  padding: 1rem;
}

.user-select-wrapper {
  label {
    display: inline-block;
  }

  input {
    width: auto;
  }
}

.today-column {
  background-color: #f0f8ff;
  /* Light blue background */
  border: 2px solid #007bff;
  /* Blue border */
}

.today-column .head {
  font-weight: bold;
  color: #007bff;
  /* Blue text for the header */
}

.today-column .body {
  background-color: #e6f7ff;
  /* Slightly darker blue for the body */
}

.visually-hidden {
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.player-report-content {
  margin-top: 1rem;
  width: 100%;
  height: 50rem;

  iframe {
    width: 100%;
    height: 100%;
  }

  .form__item {
    display: grid;
  }
}

.buttons-wrapper {
  display: flex;
  gap: 0.3rem;
}

.event-schedual-club {
  .form__input {
    width: 100%;
  }
}

.view-toggle-btn {
  margin: 0.5rem 0;
}

.list-view-wrapper {
  background: #fff;
  border-radius: 8px;
  padding: 1.5rem 1rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  width: 100%;
}

.list-date-group {
  margin-bottom: 2rem;
  border-bottom: 1px solid #eaeaea;
  padding-bottom: 1rem;
}

.list-date-header {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 0.7rem;
}

.list-event-item {
  align-items: center;
  border-radius: 6px;
  padding: 0;
  margin-bottom: 0.5rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  cursor: pointer;

  .event-wrapper {
    align-items: center;
    width: 100%;

    .player-response {
      display: flex;
      align-items: center;
      justify-content: start;
      gap: 0.5rem;
      border-top: 1px solid #c0c0c0;
      margin-top: 0.5rem;
      padding-top: 0.5rem;

      img.user-image-small {
        width: 3rem;
        height: 3rem;
        margin: 0;
        border: 1px solid #c0c0c0;
      }

      p {
        margin: 0;
      }
    }

    .response-buttons {
      display: flex;
      gap: 0.3rem;
    }
  }
}

.event-text {
  font-weight: 500;
  color: #333;
  margin-right: 0.5rem;
  display: block;
}

.event-location {
  font-size: 0.95rem;
  color: #888;
  margin-left: auto;
}

.training-style {
  background: #e6f7ff;
  border-left: 4px solid #14a2c7;

  &:hover,
  &:focus {
    background-color: #c5eeff;
  }
}

.league-style {
  background: #eafbe7;
  border-left: 4px solid #1da44f;

  &:hover,
  &:focus {
    background-color: #ceffc3;
  }
}

.cup-style {
  background: #fdf6e3;
  border-left: 4px solid #a67c00;

  &:hover,
  &:focus {
    background-color: #ffdd87;
  }
}

.other-style {
  background: #f5f5f5;
  border-left: 4px solid #6c757d;
}

.event-wrapper {
  padding: 0.3rem 0.7rem;
  border-radius: 4px;
}

.event-text[v-b-tooltip] {
  cursor: pointer;
}

.event-text {
  transition: color 0.2s;
}

.event-text:hover {
  color: #007bff;
}

.time-details-wrapper {
  font-size: 0.9rem;
  display: flex;
}

.grid-view {
  .event-location {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 188px;
  }
}

.mins-stats-wrapper {
  border-top: 1px solid #c3cdd5;
  padding: 2rem;
  overflow: hidden;
  border-top: 1px solid #c3cdd5;
  padding: 2rem;
  overflow: hidden;

  .totals {
    display: flex;
    gap: 1rem;

    .total {
      border: 1px solid #c3cdd5;
      margin: 1rem 0;
      padding: 1rem;
      min-width: 10rem;

      // ...existing code...

      p {
        font-size: 2rem;
        display: block;
        font-weight: bold;
        line-height: 2rem;
      }
    }
  }

  .date-year {
    display: block;
    text-align: center;
    margin: 0.5rem;
    width: 100%;
  }

  .mins-stats-view {
    display: flex;
    background: white;
    border: 2px solid #c3cdd5;
    overflow-x: scroll;

    .col-one-teams {
      .body:first-of-type {
        min-height: auto;
        height: auto;
        padding: 0.5rem 3rem;
        text-align: center;
        font-size: 0.8rem;
      }

      .body {
        border: 1px solid #c3cdd5;
        width: 11rem;
        padding: 0.5rem;
        font-size: 0.8rem;
        min-height: 5rem;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .mins-stats-col-one {
      background: green;
      width: 10rem;
      height: 100%;
    }

    .events {
      display: flex;
      overflow-x: scroll;
      overflow-y: hidden;

      .mins-stats-col-day-wrapper {
        .head {
          white-space: nowrap;
        }

        .body {

          &:hover,
          &:focus {
            background: #eeeeee;
            cursor: pointer;
          }

          .buttons-wrapper {
            display: flex;
            gap: 0.3rem;
            padding: 0;
            margin: 0;
          }

          .main-button {
            margin: 0;
            padding: 0.3rem;
          }
        }

        .head,
        .body {
          border: 1px solid #c3cdd5;
          text-align: center;
          padding: 0.5rem 3rem;
          font-size: 0.8rem;
        }

        .body {
          min-height: 5rem;
          border: 1px solid #e9edf0;
          height: auto;
          padding: 0.5rem;
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
          overflow-y: auto;
          max-height: 20rem;

          &::-webkit-scrollbar {
            width: 6px;
          }

          &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 3px;
          }

          &::-webkit-scrollbar-thumb {
            background: #c3cdd5;
            border-radius: 3px;
          }

          &::-webkit-scrollbar-thumb:hover {
            background: #a0aab3;
          }

          .event-wrapper.training-style {
            border-left: 3px solid #3c5746;
            background: rgb(179, 220, 244);
          }

          .event-wrapper.league-style {
            border-left: 3px solid #3c5746;
            background: rgb(179, 244, 203);
          }

          .event-wrapper {
            margin-bottom: 0;
            border-left: 3px solid;
            background: #c4fdff;
            padding: 0.2rem;
            flex-shrink: 0;

            .event-text {
              display: block;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              max-width: 188px;
            }
          }
        }
      }
    }
  }
}
</style>
